module.exports = __webpack_public_path__ + "img/happytablet_product1.3e887d93.png";